<template>
  <footer
    class="footer"
    :class="{
      'footer--fixed': $route.path === '/'
    }">
    <div
      v-if="footer"
      class="footer__half">
      <p v-html="footer.name"></p>
      <ul>
        <li>
          <a
            :href="`${footer.address.link}`"
            target="_blank"
            rel="noopener noreferrer"
            v-html="`A. ${footer.address.text}`"></a>
        </li>
        <li>
          <a
            :href="`tel:${footer.phone.link}`"
            target="_blank"
            rel="noopener noreferrer"
            v-html="`P. ${footer.phone.text}`"></a>
        </li>
      </ul>
    </div>
    <div
      v-if="footer"
      class="footer__half">
      <p
        class="byline"
        v-html="footer.byline"></p>
      <ul>
        <li>
          <a
            :href="`mailto:${footer.email.link}`"
            target="_blank"
            rel="noopener noreferrer"
            v-html="`E. ${footer.email.text}`"></a>
        </li>
        <li>
          <a
            :href="`${footer.instagram.link}`"
            target="_blank"
            rel="noopener noreferrer"
            v-html="`I. ${footer.instagram.text}`"></a>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      footer: null
    }
  },
  created() {
    this.getFooter()
    .then((footer) => {
      this.footer = footer
    })
  },
  methods: {
    getFooter() {
      return new Promise((resolve, reject) => {
        this.$http.get(`${process.env.VUE_APP_API_ADDRESS}/footer`, {
          headers: {
            'Authorization': `Basic YXBwOmNJbnAgSnUxOSBBNWRkIEVEVkIgREViNCBvZ2Rp`
          }
        })
        .then((response) => {
          resolve(response.body)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  width:100%;
  padding: 4rem $site-padding-lrg $site-padding $site-padding-lrg;
  display:flex;
  justify-content: space-between;
  align-self:flex-end;

  @media screen and (min-height: 720px) {
    &--fixed {
      position: fixed;
      bottom: 0px;
    }
  }

  &__half {
    width:calc(50% - #{$site-padding-lrg / 2});

    p {
      margin:0 0 $site-padding 0;
      font-size: $body;
      font-family: $maison;
      text-transform: uppercase;
    }
    a {
      font-size: $body;
      font-family: $maison;
      &:hover {
        color:$hover-color;
      }
    }
  }

  @include mobile {
    flex-wrap: wrap;
    padding: 2.5rem $mobile-padding 1.5rem $mobile-padding;

    &__half {
      width: 100%;

      .byline {
        margin: $site-padding 0;
      }

      p, ul li a{
        font-size: $body--m;
      }
    }
  }
}
</style>
